import "./AboutDoctor.css";
import doctorImg from "../asserts/dr_sai.jpg";
const highlights = [
  { icon: "🎓", label: "MDS Qualified", sub: "Oral health & root canal specialist" },
  { icon: "🏆", label: "Qualified Dental Surgeon", sub: "Clinical experience" },
  { icon: "❤️", label: "Patient First", sub: "Commitment to comfort" },
  { icon: "🔬", label: "Advanced Tech", sub: "Latest dental technology" },
];

export default function AboutDoctor() {
  return (
    <section className="about" id="about">
      <div className="about-inner">
        <div className="about-image-wrap">
          <div className="about-img-bg"></div>
            <div className="about-img-placeholder">
              <img 
                src={doctorImg} 
                alt="Doctor"
                className="doctor-image"
              />
            </div>
          <div className="about-exp-badge">
            <span className="badge-text">Qualified Dental Surgeon</span>
          </div>
        </div>

        <div className="about-content">
          <span className="section-tag">Meet Our Expert</span>
          <h2 className="section-title">
            Dr. P. Sai Krishna<br />
            <em>Dentistry, MDS</em>
          </h2>
          <p className="section-subtitle">
            A passionate dental professional committed to delivering exceptional oral healthcare. Specializing in oral health and root canal treatments, Dr. Sai Krishna combines clinical expertise with a gentle, patient-centric approach.
          </p>
          <p className="about-text">
            With advanced training, every treatment is tailored to meet your unique needs — ensuring you leave with not just a healthier smile, but a truly comfortable experience.
          </p>

          <div className="about-highlights">
            {highlights.map((h) => (
              <div key={h.label} className="about-highlight-item">
                <div className="ah-icon">{h.icon}</div>
                <div>
                  <div className="ah-label">{h.label}</div>
                  <div className="ah-sub">{h.sub}</div>
                </div>
              </div>
            ))}
          </div>

          <a href="#contact" className="btn-primary">
            Book a Consultation
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}